import { render, staticRenderFns } from "./ModalAddCollabMembers.vue?vue&type=template&id=86e520f8&scoped=true"
import script from "./ModalAddCollabMembers.vue?vue&type=script&lang=js"
export * from "./ModalAddCollabMembers.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCollabMembers.vue?vue&type=style&index=0&id=86e520f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e520f8",
  null
  
)

export default component.exports